module.exports = __webpack_public_path__ + "static/media/giorgio-armani-code-for-women-big.02df5cfd.png";